import Vue from 'vue';

import {
  Title,
  CustomInput,
  InputCompany,
} from '@/components';

import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

import validationFlow from '@/validation-flow';

export default {
  name: 'Step4LeasingCompany',
  components: {
    [Title.name]: Title,
    ValidationObserver,
    ValidationProvider,
    [CustomInput.name]: CustomInput,
    [InputCompany.name]: InputCompany,
  },
  props: {},
  data: () => ({

  }),
  computed: {
    ...mapGetters('appointment', {
      personalData: 'getPersonalData',
      personalDataState: 'getPersonalData',
      company: 'getCompany',
    }),
    ...mapGetters('leasingCompany', {
      leasingCompanies: 'getLeasingCompanies',
    }),
    leasingCompanyId: {
      get() {
        return this.personalDataState.leasingCompanyId;
      },
      set(newModel) {
        if (newModel != null) {
          const changePersonalDataStateObject = {
            state: newModel,
            property: 'leasingCompanyId',
          };

          this.setPersonalDataMutation(changePersonalDataStateObject);
        }

        return newModel;
      },
    },
  },
  methods: {
    ...mapActions('leasingCompany', {
      getLeasingCompanies: 'FETCH_DATA_LEASING_COMPANIES',
    }),
    setValidationMessages() {
      // Vee-validate
      // Translations are added in the PersonalDataFormComponent
      extend('objectNotEmpty', {
        validate: (value) => {
          if (value !== 0) {
            return true;
          }

          return Vue.prototype.$gettext('Validation - Leasing company');
        },
      });
    },
    goToPreviousStep() {
      this.$router.push({
        name: 'step5TireInfo',
      });
    },
    setCompanyInformation() {
      const changePersonalDataStateObject = {
        state: this.personalDataState.company,
        property: 'company',
      };

      this.setPersonalDataMutation(changePersonalDataStateObject);

      if (this.leasingCompanyId !== 0) {
        validationFlow.validateStep4LeasingCompanyInfoMobile();
      }
    },
    ...mapMutations('appointment', {
      setPersonalDataMutation: 'SET_PERSONALDATA',
      setCompany: 'SET_COMPANY',
    }),
  },
  created() {
    this.setValidationMessages();

    if (this.leasingCompanies.length === 0) {
      this.getLeasingCompanies();
    }
  },
};
